<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="key" />
    </keep-alive>

    <router-view v-if="!$route.meta.keepAlive" :key="key" />
  </div>
</template>

<script>
export default {
  computed: {
    key() {
      return this.$route.fullPath;
    },
  },
};
</script>

<style lang="scss">
html {
  overflow: hidden;
  height: -webkit-fill-available;
}
body {
  overflow: hidden;
  height: -webkit-fill-available;
}
#app {
  overflow: hidden;
  height: -webkit-fill-available;
  background: #f0f0f0;
}
</style>
